module.exports = __webpack_public_path__ + "static/img/jinguan.f0de27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jinguan.png
// module id = QIFM
// module chunks = 1